import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors, calculateSpacing } from '@vds/theme';
import { IconData } from '@vds/icons';
import { TextArea as CoreTextArea } from '@vds-core/inputs';
import { BodyConfig, Body, Micro, TypographyConfig } from '@vds/typography';
import { Tooltip } from '@vds/tooltips';

var TextArea = function TextArea(props) {
  return /*#__PURE__*/React.createElement(CoreTextArea, _extends({}, props, {
    iconConfig: IconData,
    typescale: TypographyConfig.getTypescale(),
    color: colors,
    bodyConfig: BodyConfig,
    Tooltip: Tooltip,
    Body: Body,
    Micro: Micro
  }));
};

export default TextArea;